import React from 'react';

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const SvgIcon: React.FC<SvgIconProps> = ({ Icon, ...props }) => (
  <Icon {...props} />
);

export default SvgIcon;
